import { Injectable, OnDestroy } from '@angular/core';
import { TabMenuComponent } from './tab-menu.component';
import { filter, startWith, Subject, takeUntil } from 'rxjs';
import { MenuItemExtended } from '@core/interfaces/menu-item-extended';

@Injectable({
  providedIn: 'root',
})
export class TabMenuPresenter<T, P> implements OnDestroy {
  view!: TabMenuComponent<T, P>;

  private destroy$ = new Subject<void>();

  constructor() {}

  setView(view: TabMenuComponent<T, P>): void {
    this.view = view;
    this.initialize();
    this.suscribeObservers();
  }

  private initialize(): void {
    this.view.routeItemsFrezeze = [...this.view.routeItems];
    this.view.activeTab = this.view.routeItemsFrezeze[0];
  }

  suscribeObservers(): void {
    this.view.routeItemsEnabled$
      .pipe(
        startWith([] as string[]),
        filter((routeItems) => !!routeItems?.length),
        takeUntil(this.destroy$)
      ).subscribe((routeItems) => {
        this.view.routeItems = this.view.routeItems.map((currentItem) => {
          const { id, enabled } = currentItem;
          const isEnabled = !id || !!enabled ? true : (routeItems ?? []).includes(id);

          return {
            ...currentItem,
            disabled: !isEnabled
          };
        });

        this.view.activeTab = this.view.routeItems.find((tab) => tab.id === this.view.activeTab?.id);
        this.view.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.view.onTabChange(this.view.routeItems[0]);
  }

  onTabChange(tab: MenuItemExtended<T> | undefined): void {
    if (!tab || tab?.label === this.view.lastTab?.label) return;

    this.view.lastTab = tab;
    this.view.activeTabChange.emit(
      this.view.routeItems.find((routeItem) => routeItem === tab)
    );
  }

  onDefaultTab(): void {
    this.view.onTabChange(this.view.routeItems[0]);
  }
}
